import { useCallback, useState } from 'react'

// A page's own error line (owner 2026-10-06): the sentence it shows -- from
// serverMessage(...), a check the page makes itself, anything -- and the
// failed request behind it, kept together so the line renders
// <ErrorReference error={failure} /> beside it and the reference never
// outlives its sentence.
//
//   const [error, failure, setError] = useErrorLine()
//   setError(serverMessage(err, "This couldn't be saved."), err)  // a failure
//   setError('Choose a later date.')                              // no reference
//   setError(null)                                                // clears both
export const useErrorLine = (initial = null) => {
  const [line, setLine] = useState({ message: initial, failure: null })

  const setError = useCallback((message, failure = null) => setLine({ message: message || null, failure: message ? failure : null }), [])

  return [line.message, line.failure, setError]
}
